/* eslint-disable no-unused-vars */
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal,
  Row,
  Table,
  Typography,
  notification,
} from "antd";

import React, { useEffect, useRef, useState } from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import moment from "moment";
import { useHttp } from "../../../../hooks/http";
import { getToken, URL_API } from "../../../../utils";

const { Text } = Typography;
const { Search } = Input;
const limit = 30;
const pageSize = 20;

const Index = () => {
  const [memberTypeFilter, setMemberTypeFilter] = useState("");
  const [status, setStatus] = useState("");
  const [date_from, setDateFrom] = useState(moment());
  const [date_to, setDateTo] = useState(moment());
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const memberTypeOptions = [
    { value: "", text: "ทั้งหมด" },
    { value: "Distributor", text: "นักธุรกิจ" },
    { value: "Member", text: "VIP MEMBER" },
  ];

  const [loading, data, error, reload] = useHttp(
    {
      url: `${URL_API}/tiktok/at-tiktok/orders/`,
      token: true,
      params: {
        limit,
        offset: limit * (page - 1),
        query: search,
        date_from: date_from ? moment(date_from).format("YYYY-MM-DD") : null,
        date_to: date_to ? moment(date_to).format("YYYY-MM-DD") : null,
      },
      initialLoad: true,
    },
    [search, date_from, date_to]
  );

  return (
    <Panel>
      <PanelHeader>คำสั่งซื้อ TikTok</PanelHeader>
      <PanelBody>
        <Row gutter={12} type="flex" className="align-items-center mb-5 mt-3">
          <Col span={8}>
            <Search
              placeholder="ค้นหาจาก เลขที่บิล TikTok, เลขที่บิลเลกาซี, รหัสสมาชิก, รหัสนักธุรกิจ หรือชื่อ TikTok"
              onSearch={(value) => {
                setPage(1);
                setSearch(value);
              }}
              allowClear
            />
          </Col>
          <Col span={2} className="text-right">
            <Typography.Text strong className="text-nowrap">
              วันที่เปิดบิลเลกาซี
            </Typography.Text>
          </Col>
          <Col span={6}>
            <DatePicker.RangePicker
              className="w-100"
              placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
              format="DD/MM/YYYY"
              value={[date_from, date_to]}
              onChange={(e) => {
                setDateFrom(e[0] ? moment(e[0], "DD/MM/YYYY") : null);
                setDateTo(e[1] ? moment(e[1], "DD/MM/YYYY") : null);
              }}
            />
          </Col>
        </Row>

        <Table
          bordered
          size="small"
          dataSource={data?.data.length > 0 ? data?.data : []}
          rowKey="row_id"
          loading={loading}
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: limit,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
            total: data?.data.length,
            showLessItems: true,
            size: "default",
            onChange: (currPage) => setPage(currPage),
          }}
        >
          <Table.Column title="No" dataIndex="row_id" align="left" />
          <Table.Column
            title="เลขที่บิล TikTok"
            dataIndex="tiktok_order_no"
            align="left"
          />
          <Table.Column
            title="เลขที่บิลเลกาซี"
            dataIndex="document_no"
            align="left"
          />
          <Table.Column
            title="รหัสสมาชิก/นักธุรกิจ"
            dataIndex="partner_code"
            align="left"
          />
          <Table.Column
            title="วันที่เข้าระบบเลกาซี"
            dataIndex="create_date"
            align="left"
            render={(value) =>
              value ? moment(value).format("DD/MM/YYYY") : "-"
            }
          />

          <Table.Column
            title="วันที่จัดส่ง TikTok"
            dataIndex="tiktok_date"
            align="left"
            render={(value) =>
              value ? moment(value).format("DD/MM/YYYY") : "-"
            }
          />
          <Table.Column
            title="TikTok Creator"
            dataIndex="ref_tiktok_creator"
            align="left"
          />
          <Table.Column
            title="TikTok Buyer"
            dataIndex="ref_tiktok_buyer"
            align="left"
          />
          <Table.Column title="รหัสสินค้า" dataIndex="product_code" align="left" />
          <Table.Column
            title="ชื่อสินค้า"
            dataIndex="product_name"
            align="left"
          />
          <Table.Column title="จำนวน" dataIndex="qty" align="left" />
        </Table>
      </PanelBody>
    </Panel>
  );
};

export default Index;
